<script>
	import { _ } from "svelte-i18n"
	import { previews_nav_filters, visits } from './../stores'
	import { goToLocallyStoredNavItem } from '../modules/helpers'
  import { saveSelection } from "../services/selections";
	import Button from '../elements/Button.svelte'

	let tutorial_event_sent = false

	function toggle() {
		if ($previews_nav_filters.selected) {
			goToLocallyStoredNavItem()
		}
		else {
			previews_nav_filters.filterSelected()
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth'})
			// auto-saving filtered selection
			saveSelection(undefined, true)
			sendEventsToAnalytics()
		}
	}

	function sendEventsToAnalytics() {
		if (typeof window.gtag == "undefined") return
		gtag('event', 'page_view', {
			page_title: 'Selected Fonts',
      page_location: 'https://wordmark.it/selected-fonts',
      send_to: 'G-VMWZX2CGW7'
		})

		if (tutorial_event_sent || !visits.first()) return
		gtag("event", "tutorial_complete")
    tutorial_event_sent = true
	}
	
</script>

<Button 
kind={$previews_nav_filters.selected || visits.first() || visits.second() ? 'accent' : 'default'}
scaled_in={visits.first() || visits.second()}
on:click={toggle}>
	<span slot="textIcon">
		{#if $previews_nav_filters.selected}
			←
		{:else}
			→
		{/if}
	</span>
	{#if $previews_nav_filters.selected}
	  {$_('buttons.filterOff')}
	{:else}
		{$_('buttons.filter')}
	{/if}
</Button>